import { reactive } from 'vue';

type StateType = {
  modalOpened: boolean;
  modalData: string;
  modalType: string;
};

const state = reactive<StateType>({
  modalOpened: false,
  modalData: '',
  modalType: '',
});

export default state;
